// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "close-3sn6M";
var _4 = "header-3rsII";
export { _1 as "__esModule", _2 as "mobile", _3 as "close", _4 as "header" }
export default { "__esModule": _1, "mobile": _2, "close": _3, "header": _4 }
